"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Timing = void 0;
class Timing {
    static getUtcMsNow() {
        const checktime = new Date();
        return checktime.getTime() + checktime.getTimezoneOffset() * 60 * 1000;
    }
    static over10SecondsAgo(utcms) {
        return Timing.overXSecondsAgo(utcms, 10);
    }
    static over20SecondsAgo(utcms) {
        return Timing.overXSecondsAgo(utcms, 20);
    }
    static over30SecondsAgo(utcms) {
        return Timing.overXSecondsAgo(utcms, 30);
    }
    static overAMinuteAgo(utcms) {
        return Timing.overXSecondsAgo(utcms, 60);
    }
    static overXSecondsAgo(utcms, secs) {
        return Timing.getUtcMsNow() - secs * 1000 > utcms;
    }
}
exports.Timing = Timing;
//# sourceMappingURL=Timing.js.map